module.exports = __webpack_public_path__ + "static/media/ferrari__black-white.8b052e05.jpg";